if (!customElements.get('gift-set-gallery')) {
  customElements.define(
    'gift-set-gallery',
    class GiftSetGallery extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        if (this.thumbs.length === 0) return;

        this.thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => this.goTo(index));
        });

        // Keep the active thumbnail in sync when the main images are swiped
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
            });
          },
          { root: this.viewport, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      goTo(index) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollTo({
          left: this.slides[index].offsetLeft - this.viewport.offsetLeft,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
        this.setActive(index);
      }

      setActive(index) {
        this.thumbs.forEach((thumb, i) => {
          if (i === index) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
